if (!customElements.get('kv-trust-badges')) {
  class KvTrustBadges extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.kv-trust-badges__track');
      if (!track || track.querySelector('.kv-trust-badges__item--clone')) return;

      const items = Array.from(track.querySelectorAll('.kv-trust-badges__item'));
      if (items.length < 2) return;

      const clones = document.createDocumentFragment();
      items.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.classList.add('kv-trust-badges__item--clone');
        clone.setAttribute('aria-hidden', 'true');
        clones.appendChild(clone);
      });

      track.appendChild(clones);
      track.style.removeProperty('transform');
      items.forEach((item) => item.removeAttribute('aria-hidden'));
      items[items.length - 1].classList.add('kv-trust-badges__item--last-original');
      this.classList.add('is-marquee-ready');
    }
  }

  customElements.define('kv-trust-badges', KvTrustBadges);
}
